module.exports = __webpack_public_path__ + "assets/img/17.2e2797b3.png";